import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import { CodigosTransaccionesConstant, OrigenesContabilidadConstant } from 'constants/index'

import * as Modals from './modals'

import { ZrSwal } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

const portletBreadcrumbs = [{ name: 'Presupuestos' }]

const ListaPresupuestosNuevoPage = ({ history, location }) => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)

  const idOrigen = '10PRE'
  const [mostrarClienteProveedorModal, setMostrarClienteProveedorModal] = React.useState(false)
  const [mostrarFormatosComprasModal, setMostrarFormatosComprasModal] = React.useState(false)
  const [mostrarFormatosDiariosModal, setMostrarFormatosDiariosModal] = React.useState(false)
  const [mostrarImportarPresupuestoModal, setMostrarImportarPresupuestoModal] = React.useState(false)

  const clickNuevo = React.useCallback(() => {
    if (!idOrigen) {
      __zariContext.snack('warning', 'Seleccionar origen.')
      return
    }
    history.push(`/${CodigosTransaccionesConstant.PRESUPUESTOS_NUEVO}`)
  }, [history, idOrigen, __zariContext])

  const clickNuevoConFormato = React.useCallback(() => {
    if (!idOrigen) {
      __zariContext.snack('warning', 'Seleccionar origen.')
      return
    }

    if (idOrigen === OrigenesContabilidadConstant.COMPRAS) {
      setMostrarFormatosComprasModal(true)
    } else if (idOrigen === OrigenesContabilidadConstant.DIARIO) {
      setMostrarFormatosDiariosModal(true)
    }
  }, [__zariContext, idOrigen])

  const clickImportar = React.useCallback(() => {
    setMostrarImportarPresupuestoModal(true)
  }, [])

  const headerButtons = React.useMemo(() => {
    if (idOrigen === OrigenesContabilidadConstant.DIARIO || idOrigen === '10PRE') {
      return [
        { name: 'Importar', onClick: clickImportar },
        { name: 'Nuevo', onClick: clickNuevo },
        { name: 'Nuevo con Formato', onClick: clickNuevoConFormato }
      ]
    }
    return [{ name: 'Nuevo', onClick: clickNuevo }]
  }, [idOrigen, clickNuevo, clickNuevoConFormato, clickImportar])

  const clickEditar = React.useCallback(
    async ({ _id }) => {
      if (!idOrigen) {
        __zariContext.snack('warning', 'Seleccionar origen.')
        return
      }

      history.push(`/${CodigosTransaccionesConstant.PRESUPUESTOS_NUEVO}/${_id}`)
    },
    [__zariContext, history, idOrigen]
  )

  const clickEliminar = React.useCallback(
    async ({ _id }) => {
      ZrSwal.showAlert({
        tipo: 'info',
        mensaje: '¿Desea eliminar el asiento?',
        showCerrar: true,
        onSuccess: () => {
          AsientoContableService.eliminarAsientoContable(_id)
        }
      })
    },
    []
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Lista' breadcrumbs={portletBreadcrumbs} buttons={headerButtons} />
        <Portlet.Body>
          <Table.ServerSide
            useNest={true}
            useFilters={true}
            ref={tablaRef}
            baseParams={{
              origen: idOrigen
            }}
            url='/asientos-contables'
            // preventFirstRender={preventFirstRender}
            headRows={[
              { label: 'ORIGEN', align: 'center' },
              {
                label: 'ANOMES',
                width: 70,
                align: 'center'
              },
              {
                label: 'NUM OPE',
                width: 80,
                align: 'center',
                filter: {
                  type: 'text',
                  name: 'numeroOperacion'
                }
              },
              { label: 'GLOSA', align: 'center' },
              {
                label: 'RUC',
                width: 110,
                align: 'center',
                filter: {
                  type: 'text',
                  name: 'ruc'
                }
              },
              {
                label: 'RAZON SOCIAL',
                align: 'center',
                filter: {
                  type: 'text',
                  name: 'razonSocial'
                }
              },
              { label: 'TIPO DOC.', align: 'center' },
              {
                label: 'SERIE',
                width: 70,
                align: 'center',
                filter: {
                  type: 'text',
                  name: 'serieDocumento'
                }
              },
              {
                label: 'NUMERO',
                width: 100,
                align: 'center',
                filter: {
                  type: 'text',
                  name: 'numeroDocumento'
                }
              },
              { label: '' }
            ]}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell align='center'>{row.origen || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.anoMes || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.numeroOperacion || '--'}</Table.Cell>
                <Table.Cell>{row.glosa || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.numeroDocumentoIdenficacionSocio || '--'}</Table.Cell>
                <Table.Cell>{row.razonSocialSocio || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.tipoDocumento || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.serieDocumento || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.numeroDocumento || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='editar'
                        handleClose={handleClose}
                        onClick={e => clickEditar({ _id: row._id })}
                      >
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='eliminar'
                        handleClose={handleClose}
                        onClick={e => clickEliminar({ _id: row._id })}
                      >
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarClienteProveedorModal && (
        <Modals.ClienteProveedorModal
          show={mostrarClienteProveedorModal}
          handleClose={() => setMostrarClienteProveedorModal(false)}
          origen={idOrigen}
        />
      )}
      {mostrarFormatosComprasModal && (
        <Modals.FormatosComprasModal
          show={mostrarFormatosComprasModal}
          handleClose={() => setMostrarFormatosComprasModal(false)}
          origen={idOrigen}
        />
      )}
      {mostrarFormatosDiariosModal && (
        <Modals.FormatosDiariosModal
          show={mostrarFormatosDiariosModal}
          handleClose={() => setMostrarFormatosDiariosModal(false)}
          origen={idOrigen}
        />
      )}

      {mostrarImportarPresupuestoModal && (
        <Modals.ImportarPresupuestoModal
          handleClose={e => setMostrarImportarPresupuestoModal(false)}
          show={mostrarImportarPresupuestoModal}
          reloadTable={tablaRef.current.reload}
        />
      )}
    </>
  )
}

export default ListaPresupuestosNuevoPage
